import { $api } from "../generated/client";

export function useForgotPassword() {
  return $api.useMutation("post", "/auth/forgot-password", {
    onMutate: () => {
      // TODO: Migrate x-auth-request header logic to new client
      // Add x-auth-request header to prevent token refresh interceptor from acting on this request
    },
    onSettled: () => {
      // TODO: Migrate x-auth-request header cleanup to new client
    },
  });
}
